import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import authDe from '@/shared/i18n/de/auth.json';
import categoriesDe from '@/shared/i18n/de/categories.json';
import chartDe from '@/shared/i18n/de/chart.json';
import commonDe from '@/shared/i18n/de/common.json';
import documentDe from '@/shared/i18n/de/document.json';
import forecastDe from '@/shared/i18n/de/forecast.json';
import insightDe from '@/shared/i18n/de/insight.json';
import integrationsDe from '@/shared/i18n/de/integrations.json';
import kpiTypesDe from '@/shared/i18n/de/kpi-types.json';
import kpiDe from '@/shared/i18n/de/kpi.json';
import notificationDe from '@/shared/i18n/de/notification.json';
import orgDe from '@/shared/i18n/de/org.json';
import overviewDe from '@/shared/i18n/de/overview.json';
import partnerInvitationDe from '@/shared/i18n/de/partner-invitation.json';
import partnerDe from '@/shared/i18n/de/partner.json';
import profileDe from '@/shared/i18n/de/profile.json';
import projectDe from '@/shared/i18n/de/project.json';
import sharedDe from '@/shared/i18n/de/shared.json';
import subprojectDe from '@/shared/i18n/de/subproject.json';
import subscriptionsDe from '@/shared/i18n/de/subscriptions.json';
import authEn from '@/shared/i18n/en/auth.json';
import categoriesEn from '@/shared/i18n/en/categories.json';
import chartEn from '@/shared/i18n/en/chart.json';
import commonEn from '@/shared/i18n/en/common.json';
import documentEn from '@/shared/i18n/en/document.json';
import forecastEn from '@/shared/i18n/en/forecast.json';
import insightEn from '@/shared/i18n/en/insight.json';
import integrationsEn from '@/shared/i18n/en/integrations.json';
import kpiTypesEn from '@/shared/i18n/en/kpi-types.json';
import kpiEn from '@/shared/i18n/en/kpi.json';
import notificationEn from '@/shared/i18n/en/notification.json';
import orgEn from '@/shared/i18n/en/org.json';
import overviewEn from '@/shared/i18n/en/overview.json';
import partnerInvitationEn from '@/shared/i18n/en/partner-invitation.json';
import partnerEn from '@/shared/i18n/en/partner.json';
import profileEn from '@/shared/i18n/en/profile.json';
import projectEn from '@/shared/i18n/en/project.json';
import sharedEn from '@/shared/i18n/en/shared.json';
import subprojectEn from '@/shared/i18n/en/subproject.json';
import subscriptionsEn from '@/shared/i18n/en/subscriptions.json';

export const defaultNS = 'shared';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    resources: {
      de: {
        common: commonDe,
        shared: sharedDe,
        auth: authDe,
        org: orgDe,
        profile: profileDe,
        project: projectDe,
        subproject: subprojectDe,
        kpi: kpiDe,
        kpiTypes: kpiTypesDe,
        document: documentDe,
        chart: chartDe,
        partner: partnerDe,
        partnerInvitation: partnerInvitationDe,
        overview: overviewDe,
        notification: notificationDe,
        categories: categoriesDe,
        insight: insightDe,
        forecast: forecastDe,
        subscriptions: subscriptionsDe,
        integrations: integrationsDe,
      },
      en: {
        common: commonEn,
        shared: sharedEn,
        auth: authEn,
        org: orgEn,
        profile: profileEn,
        project: projectEn,
        subproject: subprojectEn,
        kpi: kpiEn,
        kpiTypes: kpiTypesEn,
        document: documentEn,
        chart: chartEn,
        partner: partnerEn,
        partnerInvitation: partnerInvitationEn,
        overview: overviewEn,
        notification: notificationEn,
        categories: categoriesEn,
        insight: insightEn,
        forecast: forecastEn,
        subscriptions: subscriptionsEn,
        integrations: integrationsEn,
      },
    },
    defaultNS,
    supportedLngs: ['de', 'en'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
